import type { PlaybookCriterionNode } from "@repo/app-types/entities/playbook";
import { getCriteriaTrendMovementCategory } from "@repo/app-types/helpers/gradingAssessmentHelpers";

/**
 * Returns the color class for a trend delta based on the movement category.
 */
export function getTrendColorClass(
  delta: number,
  gradingValueType: PlaybookCriterionNode["grading_value_type"],
): "text-success" | "text-destructive" | "text-gray-600" {
  const category = getCriteriaTrendMovementCategory(delta, gradingValueType);

  switch (category) {
    case "improving":
      return "text-success";
    case "declining":
      return "text-destructive";
    case "flat":
      return "text-gray-600";
  }
}
